export default "__VITE_PUBLIC_ASSET__f467da2d__"